/** 订单当前阶段 */
export enum currStage {

    /** 支付阶段 */
    PAYMENT = 'payment',
    /** 发货阶段 */
    DELIVER = 'deliver',
    /** 工单阶段 */
    TICKET = 'ticket',
    /** 售后阶段 */
    POSTSALE = 'post_sale'

}

/** 支付阶段状态 */
export enum paymentStatus {

    /**
     * 订单已经创建等待用户确认支付
     */
    CREATED = 'created',

    /**
     * 用户已确认支付订单
     */
    PROCESSING = 'processing',

    /**
     * 订单已确认收款成功(终止态)
     */
    COMPLETED = 'completed',

    /**
     * 订单被用户取消，或支付超时(终止态)
     */
    CLOSED = 'closed'

}

/** 发货阶段状态 */
export enum deliverStatus {

    /** 订单等待订阅生效 */
    PENDING = 'pending',

    /** 订阅服务处理中 */
    PROCESSING = 'processing',

    /** 订阅成功生效(终止态) */
    COMPLETED = 'completed',

    /** 订阅取消生效动作(终止态) */
    CLOSED = 'closed'

}
/**
 * 工单阶段状态
 */
export enum ticketStatus {

    /**
     * 订单在 发货阶段 或者 售后阶段 关闭订单之前有工单产生
     */
    PROCESSING = 'processing',

    /** 工单成功(终止态) */
    SUCCESS = 'success',

    /** 工单失败(终止态) */
    FAILED = 'failed'

}

export enum postSaleStatus {
    /**
     * 售后阶段状态
     *
     * ready:            准备进行售后
     * refunding:        退款中
     * closed:           售后关闭(终止态)
     */

    READY = 'ready',

    REFUNDING = 'refunding',

    CLOSED = 'closed'

}

export interface IOrderStatus {
    currStage: currStage;
    paymentStatus: paymentStatus;
    deliverStatus: deliverStatus;
    ticketStatus: ticketStatus;
    postSaleStatus: postSaleStatus;
}
